import { render, staticRenderFns } from "./PlayerForm.vue?vue&type=template&id=50f76551&scoped=true&"
import script from "./PlayerForm.vue?vue&type=script&lang=js&"
export * from "./PlayerForm.vue?vue&type=script&lang=js&"
import style0 from "./PlayerForm.vue?vue&type=style&index=0&id=50f76551&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f76551",
  null
  
)

export default component.exports